import React, { useEffect, useMemo, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Input } from "antd";
// import CommonSelect from "./CommonSelect";
import CommonSelect from "../../ui-compoenents/CommonSelect";
import loginInitialValues from "./component/InitialValues";
import LoginSchema from "./component/schema";
import { DatePicker } from "antd";
import AntdDatePickerField from "../../ui-compoenents/AntdDatePickerField";

const SampleModal = ({ selectedUser }) => {
  const formRef = useRef(null);

  useEffect(() => {
    const modalElement = document.getElementById("sampleModal");
    const handleModalClose = () => {
      if (formRef.current) {
        formRef.current.resetForm();
      }
    };
    modalElement?.addEventListener("hidden.bs.modal", handleModalClose);
    return () => {
      modalElement?.removeEventListener("hidden.bs.modal", handleModalClose);
    };
  }, []);

  // Replace with your own options
  const clientOptions = [
    { label: "Jack Peterson", value: "jack" },
    { label: "Alice Watson", value: "alice" },
  ];

  const budgetOptions = [
    { label: "$1,000 - $5,000", value: "1k-5k" },
    { label: "$5,000 - $10,000", value: "5k-10k" },
  ];

  const finalInitailValues = useMemo(() => {
    if (selectedUser) {
      return {
        projectName: selectedUser?.name,
      };
    } else {
      return loginInitialValues;
    }
  }, [selectedUser]);

  return (
    <div className="modal fade" id="sampleModal" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <Formik
            innerRef={formRef}
            initialValues={finalInitailValues}
            validationSchema={LoginSchema}
            onSubmit={(actions) => {
              try {
                actions.resetForm();
                const modal = window.bootstrap.Modal.getInstance(
                  document.getElementById("sampleModal")
                );

                console.log("hello");
              } catch (error) {}
            }}
            enableReinitialize
          >
            {({ isSubmitting, actions, setFieldValue }) => (
              <Form>
                <div className="modal-header border-bottom pb-4">
                  <div>
                    <h6 className="modal-title fw-bold" id="sampleModalLabel">
                      Add New Project
                    </h6>
                  </div>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <div className="modal-body pt-0">
                  <div className="row p-2 g-3">
                    {/* Project Name */}
                    <div className="col-12">
                      <label
                        htmlFor="projectName"
                        className="form-label fw-semibold"
                      >
                        Project Name
                      </label>
                      <Field
                        id="projectName"
                        name="projectName"
                        as={Input}
                        className="custom-ant-input input-mb"
                        placeholder="Acme Corp Website Redesign"
                      />
                      <div className="text-danger small">
                        <ErrorMessage name="projectName" />
                      </div>
                    </div>

                    {/* Client */}
                    <div className="col-md-12">
                      <Field
                        name="client"
                        component={CommonSelect}
                        placeholder="Select Client"
                        options={clientOptions}
                        className="custom-ant-select input-mb"
                      />
                      <div className="text-danger small">
                        <ErrorMessage name="client" />
                      </div>
                    </div>

                    {/* Budget Range */}
                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        Budget Range
                      </label>
                      <Field
                        name="budget"
                        component={CommonSelect}
                        placeholder="Select Budget"
                        options={budgetOptions}
                        className="custom-ant-select input-mb"
                      />
                      <div className="text-danger small">
                        <ErrorMessage name="budget" />
                      </div>
                    </div>

                    {/* Start Date & Deadline */}
                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        Start Date & Deadline
                      </label>
                      <div className="d-flex gap-2">
                        <Field
                          name="startDate"
                          component={AntdDatePickerField}
                          placeholder="Select Start Date"
                        />
                      </div>
                      <div className="text-danger small">
                        <ErrorMessage name="startDate" />
                      </div>
                    </div>

                    {/* Project Description */}
                    <div className="col-12">
                      <label className="form-label fw-semibold">
                        Project Description
                      </label>
                      <Field
                        as={Input.TextArea}
                        name="description"
                        className="custom-ant-textarea input-mb"
                        placeholder="Add description"
                        rows={2}
                      />
                      <div className="text-danger small">
                        <ErrorMessage name="description" />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Modal Footer Buttons */}
                <div className="modal-footer border-top bg-white pt-3">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className="btn btn-primary btn-sm"
                    disabled={isSubmitting}
                  >
                    Create Project
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default SampleModal;
